<template>
  <IconBxStar />
</template>
